export const appFeatures = [
  {
    title: 'Call Transfer',
    content: 'Transfer calls to any internal or external number. Perfect for when you’re away from the workplace or working remotely.'
  },
  {
    title: 'Company Directory',
    content: 'Offer the best possible customer service by quickly routing calls to any one of a possible 800 directory contacts and 100 speed dials.'
  },
  {
    title: 'Call Recording',
    content: 'Record inbound and outbound calls across all VoIP devices and decide who can access what for training, compliance, or audit purposes.'
  },
  {
    title: 'Call Forwarding',
    content: 'Quick and easy call forwarding means the right person is on the call at all times. Ideal for bringing in support from senior team members.'
  },
  {
    title: 'Virtual Receptionist',
    content: 'An automated answering service with menu options to instantly direct calls to the right team members without the need for a live operator.'
  },
  {
    title: 'Call Pick Up',
    content: 'Easily answer another team member’s phone to ensure no customer is left hanging and offer the best possible experience.'
  },
  {
    title: 'Hunt Groups',
    content: 'If you’ve got a group of operators, this feature will direct incoming calls to all team members to ensure customers are always answered.'
  },
  {
    title: 'Call Waiting',
    content: 'This puts an incoming call on hold to let the caller know that you’ll soon be ready to take their call. Never miss another call.'
  },
  {
    title: 'Call Park',
    content: 'Place a caller on hold – or ‘park’ the call – while you switch to another phone in the office or hand the call to another team member.'
  },
  {
    title: 'Home Worker',
    content: 'Work from anywhere as effectively as you can from the office by taking your profiles and settings to your remote devices.'
  },
  {
    title: 'Call History',
    content: 'Check when all incoming were made and outgoing calls were received, including both those that have been answered and missed.'
  },
  {
    title: 'Authorisation Codes',
    content: 'A simple and effective way to control who has access to phones on your network. Perfect for granting employee permissions.'
  },
  {
    title: 'Do Not Disturb',
    content: 'Send calls directly to a pre-recorded voicemail message to let callers know that team members are unavailable or your business is closed.'
  },
  {
    title: 'Video Calling',
    content: 'Add video calling to offer a more personalised, face-to-face service, and screen sharing for more effective customer support.'
  },
  {
    title: 'Click to dial',
    content: 'Customers are placed directly on a call when they click the phone number on site for a seamless transition from website to phone call.'
  }
]
